import { Resource } from 'i18next'

import de from './de'
import en from './en'

export const resources: Resource = { en, de }
